import React from "react"
import { Typography } from "@mui/material"
import { getContent } from "components/Disclaimer/components/LanguageToggle"
import { provider_content } from "components/Disclaimer/content/content"

const Provider = ({ currentLanguage }) => {
  const providerStyle = {
    box: {
      marginTop: 20,
      marginBottom: 20,
    },
  }

  const contentLanguage = getContent({
    language: currentLanguage,
    content: provider_content,
  })

  return (
    <div>
      <Typography variant={"h4"}>Mercedes-Benz AG</Typography>
      <div css={providerStyle.box}>
        <Typography variant={"body1"}>Mercedesstraße 120</Typography>
        <Typography variant={"body1"}>D-70372 Stuttgart</Typography>
        <Typography variant={"body1"}>{contentLanguage.de}</Typography>
      </div>
      <div css={providerStyle.box}>
        <Typography variant={"body1"}>Phone: +49 7 11 17-0</Typography>
        <Typography variant={"body1"}>
          E-Mail: <a href="mailto:foss@mercedes-benz.com">foss@mercedes-benz.com</a>
        </Typography>
      </div>
      <div css={providerStyle.box}>
        <Typography variant={"body1"}>
          {contentLanguage?.represented}:
        </Typography>
        <Typography variant={"body1"}>
          Ola Källenius (Vorsitzender/Chairman), Jörg Burzer, Renata Jungo Brüngger, Mathias Geisen, Sabine Kohleisen, Markus Schäfer, Britta Seeger, Oliver Thöne, Hubertus Troska, Harald Wilhelm.        </Typography>
      </div>
      <div css={providerStyle.box}>
        <Typography variant={"body1"}>{contentLanguage.chairman}:</Typography>
        <Typography variant={"body1"}>Martin Brudermüller</Typography>
      </div>
      <div css={providerStyle.box}>
        <Typography variant={"body1"}>{contentLanguage.register}:</Typography>
        <Typography variant={"body1"}>{contentLanguage.registerNr}</Typography>
      </div>
      <div css={providerStyle.box}>
        <Typography variant={"body1"}>
          {contentLanguage.vat}: DE 32 12 81 763
        </Typography>
      </div>
    </div>
  )
}
export default Provider
